"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _constants = require("../../../components/page-header/constants");

var _constants2 = require("./constants");

var _action = require("../../../components/notification/action");

var _PolicyView = _interopRequireDefault(require("./PolicyView"));

var _action2 = require("../../../packages/policy-management/modules/permissions/add/action");

var _actions = require("./actions");

var _action3 = require("../../../components/spinner-overlay/action");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var _state$policyReducer, _state$policyReducer$2, _state$policyReducer2, _state$policyReducer3, _state$policyReducer4, _state$policyReducer5, _state$policyReducer6, _state$policyReducer7, _state$permissionsRed;

  var _state$policyReducer$ = state === null || state === void 0 ? void 0 : (_state$policyReducer = state.policyReducer) === null || _state$policyReducer === void 0 ? void 0 : (_state$policyReducer$2 = _state$policyReducer.view) === null || _state$policyReducer$2 === void 0 ? void 0 : _state$policyReducer$2.policyViewReducer,
      policyViewLoading = _state$policyReducer$.loading,
      policyViewData = _state$policyReducer$.data;

  var membersReducer = state.membersReducer;

  var _state$policyReducer$3 = state === null || state === void 0 ? void 0 : (_state$policyReducer2 = state.policyReducer) === null || _state$policyReducer2 === void 0 ? void 0 : (_state$policyReducer3 = _state$policyReducer2.view) === null || _state$policyReducer3 === void 0 ? void 0 : _state$policyReducer3.policyDeleteReducer,
      policyDeleteLoading = _state$policyReducer$3.loading;

  var _state$policyReducer$4 = state === null || state === void 0 ? void 0 : (_state$policyReducer4 = state.policyReducer) === null || _state$policyReducer4 === void 0 ? void 0 : (_state$policyReducer5 = _state$policyReducer4.view) === null || _state$policyReducer5 === void 0 ? void 0 : _state$policyReducer5.policyToggleReducer,
      policyToggleLoading = _state$policyReducer$4.loading;

  var _membersReducer$users = membersReducer.users,
      fetchedUsers = _membersReducer$users.data,
      fetchedUsersStatus = _membersReducer$users.status;
  var _membersReducer$group = membersReducer.groups,
      fetchedGroups = _membersReducer$group.data,
      fetchedGroupsStatus = _membersReducer$group.status;
  var _membersReducer$servi = membersReducer.serviceIdentities,
      fetchedServiceIdentities = _membersReducer$servi.data,
      fetchedServiceIdentitiesStatus = _membersReducer$servi.status;
  var _membersReducer$token = membersReducer.tokens,
      fetchedTokens = _membersReducer$token.data,
      fetchedTokensStatus = _membersReducer$token.status;

  var _state$policyReducer$5 = state === null || state === void 0 ? void 0 : (_state$policyReducer6 = state.policyReducer) === null || _state$policyReducer6 === void 0 ? void 0 : (_state$policyReducer7 = _state$policyReducer6.view) === null || _state$policyReducer7 === void 0 ? void 0 : _state$policyReducer7.policyViewJSONReducer,
      policyViewJSONLoading = _state$policyReducer$5.loading,
      policyViewJSONData = _state$policyReducer$5.data;

  state === null || state === void 0 ? void 0 : (_state$permissionsRed = state.permissionsReducer) === null || _state$permissionsRed === void 0 ? void 0 : _state$permissionsRed.permissionApplicationsList;
  var _state$consumerReduce = state.consumerReducer,
      consumerList = _state$consumerReduce.data,
      consumerListStatus = _state$consumerReduce.status;
  return {
    policyViewLoading: policyViewLoading,
    policyViewData: policyViewData,
    policyDeleteLoading: policyDeleteLoading,
    policyToggleLoading: policyToggleLoading,
    fetchedUsers: fetchedUsers,
    fetchedUsersStatus: fetchedUsersStatus,
    fetchedGroups: fetchedGroups,
    fetchedGroupsStatus: fetchedGroupsStatus,
    fetchedServiceIdentities: fetchedServiceIdentities,
    fetchedServiceIdentitiesStatus: fetchedServiceIdentitiesStatus,
    fetchedTokens: fetchedTokens,
    fetchedTokensStatus: fetchedTokensStatus,
    policyViewJSONLoading: policyViewJSONLoading,
    policyViewJSONData: policyViewJSONData,
    consumerList: (consumerList === null || consumerList === void 0 ? void 0 : consumerList.result) || [],
    consumerListStatus: consumerListStatus
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPolicyById: function getPolicyById(policyId, history, consumer, consumerEntityId, redirectPath) {
      var payload = {
        policyId: policyId,
        history: history,
        consumer: consumer,
        consumerEntityId: consumerEntityId,
        redirectPath: redirectPath
      };
      dispatch((0, _actions.getPolicyByIdRequest)(payload));
    },
    deletePolicyById: function deletePolicyById(policyId, history, consumer, consumerEntityId, redirectPath) {
      var payload = {
        policyId: policyId,
        history: history,
        consumer: consumer,
        consumerEntityId: consumerEntityId,
        redirectPath: redirectPath
      };
      dispatch({
        type: _constants2.PolicyDeleteDataTypes.POLICY_DELETE_DATA_REQUEST,
        payload: payload
      });
    },
    openNotification: function openNotification(_ref) {
      var type = _ref.type,
          title = _ref.title,
          open = _ref.open,
          duration = _ref.duration;
      return dispatch((0, _action.openNotification)(type, title, open, duration));
    },
    setPageHeader: function setPageHeader(title, routeToNameList) {
      return dispatch({
        type: _constants.HeaderConstants.HEADER_PROPS,
        payload: {
          title: title,
          routeToNameList: routeToNameList
        }
      });
    },
    resetPolicyView: function resetPolicyView() {
      dispatch({
        type: _constants2.PolicyViewDataTypes.POLICY_VIEW_DATA_RESET,
        payload: {}
      });
    },
    togglePolicyRequest: function togglePolicyRequest(payload) {
      dispatch({
        type: _constants2.PolicyViewDataTypes.POLICY_VIEW_TOGGLE_REQUEST_INIT,
        payload: payload
      });
    },
    getApplicationsList: function getApplicationsList() {
      return dispatch((0, _action2.requestApplicationList)());
    },
    getPolicyByName: function getPolicyByName(policyName, history, consumer, consumerEntityId, redirectPath) {
      var payload = {
        policyName: policyName,
        history: history,
        consumer: consumer,
        consumerEntityId: consumerEntityId,
        redirectPath: redirectPath
      };
      dispatch((0, _actions.getPolicyByNameRequest)(payload));
    },
    getPolicyByIdReset: function getPolicyByIdReset() {
      return dispatch((0, _actions.getPolicyByIdReset)());
    },
    getPolicyByNameReset: function getPolicyByNameReset() {
      return dispatch((0, _actions.getPolicyByNameReset)());
    },
    initSpinnerOverlay: function initSpinnerOverlay(_ref2) {
      var open = _ref2.open,
          size = _ref2.size,
          message = _ref2.message;
      return dispatch((0, _action3.initSpinnerOverlay)({
        open: open,
        size: size,
        message: message
      }));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PolicyView.default);

exports.default = _default;